var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"sb-topnav navbar navbar-expand navbar-light this-topnav"},[_vm._t("application-name"),_vm._t("toggle-button"),_vm._t("navbar-menu-left"),_vm._t("navbar-search"),_vm._t("navbar-free-slot"),_vm._t("navbar-menu-right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }